<template>
  <div class="tooltip-c">
    <img
      :src="$env.public_base + '/assets/images/info-icon.svg'"
      alt="info"
    />
    <ul class="tooltip-c__content">
      <li class="tooltip-c__header">
        <span>{{ $t('for_grades') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--white" style="border:1px solid #eee;"></i>
        <span>{{ $t('diary_status.9') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--red">9</i>
        <span>{{ $t('diary_status.10') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--gray"></i>
        <span>{{ $t('diary_status.1') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--orange"></i>
        <span>{{ $t('diary_status.2') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--yellow"></i>
        <span>{{ $t('diary_status.3') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--red"></i>
        <span>{{ $t('diary_status.4') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--red">1</i>
        <span>{{ $t('diary_status.5') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--fiol"></i>
        <span>{{ $t('diary_status.6') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--green"></i>
        <span>{{ $t('diary_status.7') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--green">1</i>
        <span>{{ $t('diary_status.8') }}</span>
      </li>

      <li>
        <i class="diary-status diary-status--gray"></i>
        <span>{{ $t('diary_status.11') }}</span>
      </li>

      <template v-if="isTeacher">
        <li class="tooltip-c__header mt-15">
          <span>{{ $t('for_students_list') }}</span>
        </li>

        <li>
          <i class="diary-status diary-status--pink"></i>
          <span>{{ $t('diary_status.21') }}</span>
        </li>

        <li>
          <i class="diary-status diary-status--yellow-2"></i>
          <span>{{ $t('diary_status.22') }}</span>
        </li>

        <li>
          <i class="diary-status diary-status--red-text">{{ $t('full_name') }}</i>
          <span>{{ $t('diary_status.23') }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isTeacher: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
